import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone, FaDownload } from 'react-icons/fa';
import { Link } from 'react-scroll';
 
const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section className="hero" id="home">
      <div className="hero-background">
        <div className="gradient-circle circle-1"></div>
        <div className="gradient-circle circle-2"></div>
        <div className="gradient-circle circle-3"></div>
      </div>

      <div className="container">
        <motion.div
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Profile Picture */}
          <motion.div 
            className="profile-image-container"
            variants={itemVariants}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <div className="profile-image-wrapper">
              <img 
                src="/profile.jpeg" 
                alt="Saba Atta Muhammad" 
                className="profile-image"
                onError={(e) => {
                  // Fallback if image doesn't load
                  e.target.src = "https://ui-avatars.com/api/?name=Saba+Atta+Muhammad&size=400&background=6366f1&color=fff&bold=true&font-size=0.4";
                }}
              />
              <div className="profile-ring"></div>
              <div className="profile-ring-2"></div>
            </div>
          </motion.div>

          <motion.div className="hero-badge" variants={itemVariants}>
            <span>👋 Welcome to my portfolio</span>
          </motion.div>

          <motion.h1 className="hero-title" variants={itemVariants}>
            Hi, I'm <span className="gradient-text">Saba Atta Muhammad</span>
          </motion.h1>

          <motion.h2 className="hero-subtitle" variants={itemVariants}>
            MERN Stack Developer
          </motion.h2>

          <motion.p className="hero-description" variants={itemVariants}>
            Building scalable, high-performance web applications with <strong>2.8+ years</strong> of expertise in{' '}
            <span className="highlight">MongoDB, Express.js, React.js, Node.js, Next.js & TypeScript</span>.
            Specialized in AI integration, advanced state management, and delivering exceptional user experiences.
          </motion.p>

          <motion.div className="hero-stats" variants={itemVariants}>
            <div className="stat">
              <h3>2.8+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat">
              <h3>15+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat">
              <h3>100%</h3>
              <p>Client Satisfaction</p>
            </div>
          </motion.div>

          <motion.div className="hero-buttons" variants={itemVariants}>
            <Link to="projects" smooth={true} offset={-70} duration={500}>
              <button className="btn btn-primary">View My Work</button>
            </Link>
            <Link to="contact" smooth={true} offset={-70} duration={500}>
              <button className="btn btn-outline">Get In Touch</button>
            </Link>
          </motion.div>

          <motion.div className="hero-social" variants={itemVariants}>
            <a href="https://github.com/sabaattaa" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/saba-atta-muhammad-7125072a1/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="mailto:sabaatta66170@gmail.com" aria-label="Email">
              <FaEnvelope />
            </a>
            <a href="tel:+923284796617" aria-label="Phone">
              <FaPhone />
            </a>
          </motion.div>
        </motion.div>
      </div>

      <div className="scroll-indicator">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;